import { PolaroidCard } from './src/PolaroidCard';
import { PolaroidCardTitle } from './src/PolaroidCardTitle';

PolaroidCard.Title = PolaroidCardTitle;

export { PolaroidCard };
